var _componentModalRemote = function() {
    $('.js-modal-remote').each(function() {
        var $me = $(this);
        
        $($me.data('target')).on('show.bs.modal', function() {
            var $modal = $(this);
            
            if ($modal.data('ajax-succeded') === undefined) {
                $.ajax({
                    type: "POST",
                    url: $me.data('source'),
                    data: $me.data('params') ? $me.data('params') : '',
                    cache: false,
                    success: function (htmlresult) {
                        $modal.find('.js-modal-body').html(htmlresult);
                        $modal.data('ajax-succeded', true);
                    }
                });
            }
        });          
    });
};

// Bootbox extension
var _componentModalBootbox = function() {
    if (typeof bootbox == 'undefined') {
        console.warn('Warning - bootbox.min.js is not loaded.');
        return;
    }
    
    var loader = new ciBodyLoader();
    loader.init();

    // Confirm modal
    $(document).on('click', '.js-confirm-modal', function() {
        var $me = $(this);
        
        bootbox.confirm({
            title: $me.data('title') ? $me.data('title') : 'Ressource entfernen',
            message: $me.data('message') ? $me.data('message') : 'Sind Sie sicher, dass Sie die ausgewählte Ressource entfernen möchten?',
            buttons: {
                confirm: {
                    label: 'Ok',
                    className: 'btn-primary'
                },
                cancel: {
                    label: 'Abbrechen',
                    className: 'btn-link'
                }
            },
            callback: function (result) {
                if (result) {
                    loader.show();
                    window.location = $me.attr('href') == 'undefined' ? $me.data('href') : $me.attr('href') ;
                }
            }
        });
        
        return false;
    });
    
    // Confirm modal with options
    $(document).on('click', '.js-confirm-modal-with-options', function() {
        var $me = $(this);
        var labels = $me.data('labels') ? $me.data('labels') : [],
            actions = $me.data('actions') ? $me.data('actions') : [],
            classes = $me.data('classes') ? $me.data('classes') : [];
        var buttonsSet = {};
        
        if (labels.length) {
            $.each(labels, function(k, v) {
                buttonsSet['option'+k] = {
                    label: v,
                    className: classes[k] ? classes[k] : 'btn-primary',
                    callback: function() {
                        window.location = actions[k] ? actions[k] : $me.attr('href');
                    }
                };
            });
            bootbox.dialog({
                title: $me.data('title') ? $me.data('title') : 'Ressource entfernen',
                message: $me.data('message') ? $me.data('message') : 'Sind Sie sicher, dass Sie die ausgewählte Ressource entfernen möchten?',
                buttons: buttonsSet
            });
        } else {
            bootbox.confirm({
                title: $me.data('title') ? $me.data('title') : 'Ressource entfernen',
                message: $me.data('message') ? $me.data('message') : 'Sind Sie sicher, dass Sie die ausgewählte Ressource entfernen möchten?',
                buttons: {
                    confirm: {
                        label: 'Ok',
                        className: 'btn-primary'
                    },
                    cancel: {
                        label: 'Abbrechen',
                        className: 'btn-link'
                    }
                },
                callback: function (result) {
                    if (result) {
                        window.location = $me.attr('href') == 'undefined' ? $me.data('href') : $me.attr('href') ;
                    }
                }
            });
        }
        return false;
    });    
};

function init() {
    _componentModalRemote();
    _componentModalBootbox();
}

export const Modals = {
    init
}